import { Theme } from '@mui/material';

import { paletteBase } from '@abg/kit-base';
import { AbgSxProps } from '@abg/typings';

export const containerStyles: AbgSxProps = (theme: Theme) => ({
  display: 'flex',
  flexDirection: 'column',
  gap: '2px',
  padding: '16px 16px 24px 16px !important',
  borderRadius: `${theme.borderRadius.action}px`,
  border: '1px solid rgba(44, 98, 147, 0.20)',
  background: paletteBase.aliceBlue,
});

export const headerStyles: AbgSxProps = {
  display: 'flex',
  gap: '4px',
};

export const titleStyles: AbgSxProps = {
  flex: '1 0 0',
  color: '#2C6293',
  fontSize: '14px',
  fontStyle: 'normal',
  fontWeight: 700,
  lineHeight: '20px',
  letterSpacing: '0.042px',
  margin: '0',
};

export const contentStyles: AbgSxProps = {
  display: 'flex',
  flexDirection: 'column',
  gap: '16px',
  flex: '1 0 0',
  padding: '0px 16px',
};

export const progressStyles: AbgSxProps = {
  display: 'flex',
  flexDirection: 'column',
  gap: '8px',
};

export const progressTextStyles: AbgSxProps = {
  color: '#2C6293',
  fontSize: '12px',
  fontStyle: 'normal',
  fontWeight: 400,
  lineHeight: '16px',
};

export const barStyles: AbgSxProps = {
  display: 'flex',
  gap: '2px',
};

export const barItemStyles = (isCompleted: boolean) => (theme: Theme) => ({
  width: '15px',
  height: '6px',
  borderRadius: `${theme.borderRadius.smallCard}px`,
  backgroundColor: isCompleted ? '#2C6293' : 'rgba(31, 29, 29, 0.40)',
});

export const infoIconStyles: AbgSxProps = {
  color: '#2C6293',
  fontSize: '12px',
  marginTop: '4px',
};

export const closeIconStyles: AbgSxProps = {
  cursor: 'pointer',
  color: '#2C6293',
  fontSize: '12px',
  marginTop: '4px',
};

export const ctaStyles: AbgSxProps = {
  color: '#000',
  fontSize: '12px',
  fontStyle: 'normal',
  fontWeight: 400,
  lineHeight: '12px',
  letterSpacing: '0.036px',
  textDecoration: 'underline',
};
